import React, {Fragment, h} from "preact";
import {t} from '../../../_i18n';
import {connect} from "react-redux";
import CardUpcomingExamView from "../components/CardUpcomingExamView";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";
import {isSpanishUser} from "../../../_common/utils/getLang";
import {useEffect, useState} from "preact/hooks";
import ModalGraceConvocationRequest from "../components/ModalGraceConvocationRequest";
import {Card} from "../../../_common/layout";
import {ButtonGhost} from "../../../_common/components/buttons/buttons";
import Badge from "../../../_common/components/Badge";

function UpcomingExams({examsStatus, studentMeta}) {
    const [showGraceConvocationAlert, setShowGraceConvocationAlert] = useState(false)
    const [graceConvocationStatus, setGraceConvocationStatus] = useState(examsStatus.grace_document_status ?? null)
    const [showGraceConvocationModal, setShowGraceConvocationModal] = useState(false)

    const showCurrentEvents = examsStatus?.current?.formative_actions?.length > 0 && !examsStatus?.current?.ended_enroll_period
    const showNextEvents = examsStatus?.next?.formative_actions?.length > 0 && !examsStatus?.next?.ended_enroll_period
    const exams_limit_string = t('exams_date_limit_2').replace('{EXAM_DATE_LIMIT}', examsStatus?.current?.end_date_join)
    const no_pending_inscriptions_string = t('no_pending_inscriptions')

    useEffect(() => {
        const graceDocumentStatus = examsStatus?.grace_document_status || {};

        let showGraceConvocation = Object.entries(graceDocumentStatus).some(
            ([key, value]) => key !== 'validated' && value.length > 0
        );

        setGraceConvocationStatus(graceDocumentStatus);
        setShowGraceConvocationAlert(showGraceConvocation);

    }, [examsStatus?.grace_document_status]);

    const onCloseGraceConvocationModal = (newStatus) => {
        console.log(newStatus)
        if (Object.hasOwn(newStatus, 'pending') && Object.hasOwn(newStatus, 'refused') && Object.hasOwn(newStatus, 'sent')) {
            let showGraceConvocation = Object.entries(newStatus).some(
                ([key, value]) => key !== 'validated' && value.length > 0
            );

            setShowGraceConvocationAlert(showGraceConvocation);
            setGraceConvocationStatus(newStatus)
        }
        setShowGraceConvocationModal(false)
    }


    const current_markdown = (
        <div>
            <p className='m-top-x2 m-bottom font-20 font-color-486268'>{t('Exámenes de asignaturas que estás cursando')}:</p>
            { showCurrentEvents && isSpanishUser(studentMeta.shop_id) &&
                <AlertBox type='info' className='m-top sm-no-m-top'>
                    <span dangerouslySetInnerHTML={{__html: exams_limit_string}}/>
                </AlertBox>
            }

            { showGraceConvocationAlert &&
                <Fragment>
                    <ModalGraceConvocationRequest
                        visible={showGraceConvocationModal}
                        graceConvocationStatus={graceConvocationStatus}
                        closeModal={onCloseGraceConvocationModal}
                    />
                    <Card className='m-top' smOnly={false}>
                        <div>
                            <p>{t('grace_convo_1')}</p>
                            <ul>
                                {graceConvocationStatus.pending.length > 0 && graceConvocationStatus.pending.map(fa =>
                                    <li className='m-bottom'>
                                        <span className='m-r'>
                                            {fa.formative_action_code}. <b>{fa.formative_action_title}</b>
                                        </span>
                                    </li>)
                                }
                                {graceConvocationStatus.sent.length > 0 && graceConvocationStatus.sent.map(fa =>
                                    <li className='m-bottom'>
                                        <div className='d-flex flex-column sm-d-block'>
                                            <span className='m-r'>
                                                {fa.formative_action_code}. <b>{fa.formative_action_title}</b>
                                            </span>
                                            <Badge className="width-fit-content badge-dark-gray font-small font-color-white">
                                                {t('Convocatoria solicitada')}
                                            </Badge>
                                        </div>
                                    </li>)
                                }
                                {graceConvocationStatus.refused.length > 0 && graceConvocationStatus.refused.map(fa =>
                                    <li className='m-bottom'>
                                        <div className='d-flex flex-column sm-d-block'>
                                            <span className='m-r'>
                                                {fa.formative_action_code}. <b>{fa.formative_action_title}</b>
                                            </span>
                                            <Badge className="width-fit-content badge-dark-red font-small font-color-white">
                                                {t('Solicitud rechazada')}
                                            </Badge>
                                        </div>
                                    </li>)
                                }
                            </ul>
                            { graceConvocationStatus.sent.length < 1 && graceConvocationStatus.pending.length > 0 ?
                                <Fragment>
                                    <AlertBox type='info' className='m-top sm-no-m-top'>
                                        <span dangerouslySetInnerHTML={{__html: t('grace_convo_alert')}}/>
                                    </AlertBox>
                                    <p class="m-top m-bottom" dangerouslySetInnerHTML={{__html: t('grace_convo_2')}} />
                                </Fragment>
                                :
                                <AlertBox type='info' className='m-top sm-no-m-top m-bottom'>
                                    <span dangerouslySetInnerHTML={{__html: t('grace_convo_sent')}}/>
                                </AlertBox>
                            }
                        </div>
                        {(graceConvocationStatus.pending.length > 0 || graceConvocationStatus.refused.length > 0) &&
                            <div>
                                <ButtonGhost className='t-upper full-width sm-no-full-width font-14'
                                             onClick={() => setShowGraceConvocationModal(true)}>
                                    {t('Solicitar convocatoria')}
                                </ButtonGhost>
                            </div>
                        }
                    </Card>
                </Fragment>

            }

            {
                showCurrentEvents && examsStatus?.current?.formative_actions.filter(
                    event => !graceConvocationStatus?.pending?.includes(event) && !graceConvocationStatus?.sent?.includes(event)
                ).map(event => <
                    CardUpcomingExamView event={event} isNextTerm={false}/>)
            }
        </div>
    )

    const next_markdown = (showNextEvents &&
        <div>
            <p className='m-top-x2 m-bottom font-20 font-color-486268'>{t('Exámenes de asignaturas del próximo periodo')}:</p>
            {examsStatus?.next?.formative_actions.some(event => event.bought_all_items_for_academic_program === false) &&
              <AlertBox className='m-x2-bottom d-flex flex-baseline-y' type={'info'}>
                  <span class="text-responsive" dangerouslySetInnerHTML={{__html: t('2122_cancelado_derecho_examen')}}></span>
              </AlertBox>
            }
            {examsStatus?.next?.formative_actions.map(event => <CardUpcomingExamView event={event} isNextTerm={true}/>)}
        </div>
    )

    return <Fragment>
        {!this.props.provisional_is_next &&
            <Fragment>
                { (showCurrentEvents || showNextEvents) &&
                    <div className='m-bottom font-heavy font-30 font-color-486268'>
                        {t('Inscripciones pendientes')}
                    </div>
                }
                {!showCurrentEvents && !showNextEvents && !showGraceConvocationAlert &&
                    <AlertBox type='info' className='m-top sm-no-m-top'>
                        {no_pending_inscriptions_string}
                    </AlertBox>
                }
            </Fragment>
        }
        {!this.props.provisional_is_next && current_markdown}
        {this.props.provisional_is_next && next_markdown}
    </Fragment>
}

UpcomingExams = connect(
    ({status, enrollmentExams}) => ({
        examsStatus: enrollmentExams.examsStatus,
        studentMeta: status.student_meta,
    }),
    {})(UpcomingExams);


export default ({...rest}) => {
    return (<UpcomingExams {...rest} />);
}
